import './index.scss'
$("header .nav a").eq(0).addClass("active")